const gray = {
  50: "#fafafa",
  100: "#f4f4f5",
  200: "#e4e4e7",
  300: "#d4d4d8",
  350: "#b0b0b9",
  400: "#a1a1aa",
  450: "#8a8a96",
  500: "#71717a",
  600: "#52525b",
  700: "#3f3f46",
  800: "#27272a",
  900: "#18181b",
}

const colors = {
  gray,
  primary: gray,
  black: {
    50: "#000000",
    100: "#000000",
    200: "#050505",
    300: "#0f0f10",
    400: "#18181b",
    500: "#222225",
    600: "#18181b",
    700: "#0f0f10",
    800: "#050505",
    900: "#000000",
  },
  red: {
    50: "#fef2f2",
    100: "#fee2e2",
    200: "#fecaca",
    300: "#fca5a5",
    400: "#f87171",
    500: "#ef4444",
    600: "#dc2626",
    700: "#b91c1c",
    800: "#991b1b",
    900: "#7f1d1d",
  },
  blue: {
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#1e3a8a",
  },
  green: {
    50: "#f0fdf4",
    100: "#dcfce7",
    200: "#bbf7d0",
    300: "#86efac",
    400: "#4ade80",
    500: "#22c55e",
    600: "#16a34a",
    700: "#15803d",
    800: "#166534",
    900: "#14532d",
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666",
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#837c60",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E",
  },
  indigo: {
    50: "#EEF2FF",
    100: "#E0E7FF",
    200: "#C7D2FE",
    300: "#A5B4FC",
    400: "#818CF8",
    500: "#6366F1",
    600: "#4F46E5",
    700: "#4338CA",
    800: "#3730A3",
    900: "#312E81",
  },
  salmon: {
    50: "#FFEFF1",
    100: "#FFE6E8",
    200: "#FFBDC3",
    300: "#FF929C",
    400: "#FF737F",
    500: "#FE4958",
    600: "#FE2538",
    700: "#D5202F",
    800: "#9D010D",
    900: "#920000",
  },
  gold: {
    50: "#F9F5E5",
    100: "#F7F0CD",
    200: "#F5EAB9",
    300: "#E4CD9B",
    400: "#D7B886",
    500: "#C1A071",
    600: "#A7895F",
    700: "#8D734E",
    800: "#735C3D",
    900: "#58452C",
  },
  DISCORD: {
    50: "#eef2ff",
    100: "#e0e7ff",
    200: "#c7d2fe",
    300: "#a5b4fc",
    400: "#818cf8",
    500: "#5768ea",
    600: "#4f46e5",
    700: "#4338ca",
    800: "#3730a3",
    900: "#312e81",
  },
  GATHER_TOWN: {
    50: "#F2F4FC",
    100: "#E6E8FA",
    200: "#C0C7F2",
    300: "#95A1E9",
    400: "#6B7CE0",
    500: "#4358D8",
    600: "#2C43D3",
    700: "#273DBE",
    800: "#2336A9",
    900: "#1F2F94",
  },
  TELEGRAM: {
    50: "#F0F9FF",
    100: "#E0F2FE",
    200: "#BAE6FD",
    300: "#7DD3FC",
    400: "#38BDF8",
    500: "#239edc",
    600: "#0284C7",
    700: "#0369A1",
    800: "#075985",
    900: "#0C4A6E",
  },
  POAP: {
    50: "#FDEDEF",
    100: "#FCDADE",
    200: "#FBC6CC",
    300: "#FAAFB8",
    400: "#F995A1",
    500: "#F87588",
    600: "#E26A7C",
    700: "#CA5F6E",
    800: "#AF5260",
    900: "#8E434E",
  },
  GUILD: {
    50: "#212121",
    100: "#212121",
    200: "#212121",
    300: "#212121",
    400: "#212121",
    500: "#212121",
    600: "#212121",
    700: "#212121",
    800: "#212121",
    900: "#212121",
  },
  WEB3INBOX: {
    50: "#D6FFFE",
    100: "#A4FEFD",
    200: "#01F3EF",
    300: "#01DFDB",
    400: "#01C1BD",
    500: "#01A29E",
    600: "#019391",
    700: "#017F7D",
    800: "#016A69",
    900: "#004C4B",
  },
  UNISWAP: {
    50: "#ffe5f2",
    100: "#ffb3d7",
    200: "#ff80bd",
    300: "#ff4da2",
    400: "#ff1a87",
    500: "#e6006e",
    600: "#b30055",
    700: "#80003d",
    800: "#4d0025",
    900: "#1a000c",
  },
  FARCASTER: {
    50: "#f3f3fd",
    100: "#dadafa",
    200: "#c1c2f6",
    300: "#a8aaf3",
    400: "#8f91ef",
    500: "#7679ec",
    600: "#5e61e8",
    700: "#4548e5",
    800: "#2c30e1",
    900: "#1e22d3",
  },
}

export default colors
